import { lazy } from "react";

const ListRecordingPage = lazy(() => import("./main"));

const UpdateRecordingPage = lazy(() => import("./update"));

export { ListRecordingPage, UpdateRecordingPage };
